import axios from "axios";

export const configureAxios = async (token) => {
    axios.defaults.headers.common['Authorization'] = `bearer ${token}`
}